export const searchArticle = async (query, page, category, locale) => {
    try {
        const res = await fetch(`/api/learn/search?query=${query}&page=${page}&category=${category}&locale=${locale}`)
        return await res.json()
    }
    catch (e) {
        console.error(e)
    }
}